import { Check, FolderOpen } from "lucide-react";
import type { BuildingProject } from "@/types/projects";
import { cn } from "@/lib/utils";
import { ProjectStatusBadge } from "@/domains/projects/status/ProjectStatusBadge";

// The red folder icon used by every project row — plain background, only the
// glyph is tinted.
const ProjectIconTile = () => (
  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg">
    <FolderOpen className="h-5 w-5 text-primary" />
  </span>
);

/**
 * One selectable project row with name, optional description and a meta line.
 * Extracted from the retired folders-page ProjectSelector (WHA-3865); used by
 * the sidebar chat's "work in project" picker.
 */
export const ProjectOptionRow = (props: {
  project: BuildingProject;
  meta: string;
  isSelected: boolean;
  onSelect: () => void;
}) => {
  const { project, meta, isSelected, onSelect } = props;
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-muted/50",
        isSelected && "bg-primary/5"
      )}
    >
      <ProjectIconTile />
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <ProjectStatusBadge variant="dot" status={project.status} />
          <span className="truncate font-semibold">{project.name}</span>
        </span>
        {project.description && (
          <span className="block truncate text-sm text-foreground/80">{project.description}</span>
        )}
        <span className="block truncate text-sm text-muted-foreground">{meta}</span>
      </span>
      {isSelected && <Check className="h-4 w-4 shrink-0 text-primary" />}
    </button>
  );
};
